/*
 * The AI chats a document's byline may name for this reader (A-4 A4-D9; core's slot `chatLabels`):
 * "Claude, asked by Ben in *Pricing rework*" to a reader of the chat, the chat a link. An AI chat's
 * readers are its owners, and the slice holds every chat the reader owns that the lists know of — what
 * the server told this reader and nobody else — so a chat it holds is a chat they read. A chat it does
 * not hold (one closed long ago, one the lists never paged in) is left out, and the byline reads
 * "Claude, asked by Ben": it may say too little, never name a chat to somebody outside it.
 *
 * The answer is kept while the chats and their titles keep their identity, so core selects it from
 * the model and repaints a byline only when a chat or a title changed.
 */

import type { ChatLabel } from "../../core/modules/registry.ts"
import type { Model } from "../../core/store/model.ts"
import { aiChatHref } from "../../routes/links.ts"
import { aichatSlice, type AichatSlice } from "./sync/slice.ts"

/** The last answer, for the chats and titles it was made from. */
let kept: {
	chats: AichatSlice["chats"]
	titles: AichatSlice["titles"]
	labels: ReadonlyMap<number, ChatLabel>
} | null = null

/** Every chat of the reader's with a title, by chat id: its title and where it opens. */
export function aichatChatLabels(model: Model): ReadonlyMap<number, ChatLabel> {
	const { chats, titles } = aichatSlice(model)
	if (kept !== null && kept.chats === chats && kept.titles === titles) return kept.labels
	const labels = new Map<number, ChatLabel>()
	for (const row of Object.values(chats)) {
		const title = titles[row.chatId] ?? ""
		if (title !== "") labels.set(row.chatId, { title, href: aiChatHref(row.key) })
	}
	kept = { chats, titles, labels }
	return labels
}
